import { useEffect, useState } from 'react';
import { ListBoxItem } from 'react-aria-components';
import { ComboBox } from 'components/select/ComboBox';
import { useHasPermission } from '@hooks/has-permission/useHasPermission';
import { useGetAllCodeReasonsQuery } from '@api/list-data/api';
import { SelectReasonType } from 'components/select-reason-cell/SelectReasonType';



interface SelectReasonCellProps {
	type: SelectReasonType,
	value: string | null | undefined,
	onChange: (reason: { id: string, name: string }) => void,
	requiredRoles: string | string[],
	isApiError: boolean,
	className?: string,
}


export const SelectReasonCell = (props: SelectReasonCellProps) => {
	const { type, value, onChange, className, isApiError, requiredRoles } = props;

	const hasPermission = useHasPermission();
	const permissionToEdit = requiredRoles ? hasPermission(requiredRoles) : true;

	const { data, isLoading, isFetching, isError } = useGetAllCodeReasonsQuery();
	const [ tempValue, setTempValue ] = useState(value);

	
	useEffect(() => {
		setTempValue(value);
	}, [ value ]);

	
	return (
		<div className={`select-reason-cell ${className}`}>
			<ComboBox
				aria-label='Důvod z plánování'
				defaultItems={
					data
					? [
						{ id: '', text: '' },
						...data.filter(x =>
							type === SelectReasonType.planningReason
							? x.id.startsWith('sap_')
							: x.id.startsWith('mdsd_')
						)
						.toSorted((a,b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0))
						.map(x => ({ id: x.text, text: x.text}))
					]
					: []
				}
				isDisabled={isLoading || isFetching}
				errorMessage={isApiError ? 'Problém při ukládání dat' : 'Problém při načítání dat'}
				isInvalid={isApiError || isError}
				selectedKey={tempValue ? tempValue : ''}
				onSelectionChange={selected => {
					if (selected === null || selected === undefined || typeof selected !== 'string' || !permissionToEdit || !data)
						return;
					
					if (selected === '') {
						onChange({ id: '', name: '' });
						setTempValue('');
						return;
					}

					const selectedOption = data
						.filter(x => type === SelectReasonType.planningReason ? x.id.startsWith('sap_') : x.id.startsWith('mdsd_'))
						.find(reasonCode => selected === reasonCode.text);
					if (selectedOption) {
						onChange({ id: selectedOption.id, name: selectedOption.text });
						setTempValue(selectedOption.text);
					}
				}}
			>
				{(item) => <ListBoxItem id={item.id}>{item.text}</ListBoxItem>}
			</ComboBox>
		</div>
	);
}